function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 154.43 70.624)",
  className: "st0"
}, "Daylight");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M56.3,69.5c-13.5-0.1-24.5-11.1-24.4-24.6C32,31.5,43,20.5,56.5,20.6s24.4,11.2,24.4,24.7 C80.8,58.6,69.8,69.5,56.3,69.5z M77.3,45.2c0.1-11.6-9.3-21-20.8-21.1s-21.1,9.3-21.1,20.7C35.3,56.5,44.8,66,56.3,66 C67.8,66.1,77.3,56.6,77.3,45.2z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M58.1,80c0,1.7,0,3.4,0,5.1c0,1.1-0.6,2-1.7,1.9c-1.1,0-1.7-0.8-1.7-2c0-3.3,0-6.6,0-9.9c0-1.1,0.5-2,1.6-2 c1.3,0,1.8,0.8,1.8,2C58,76.7,58.1,78.4,58.1,80z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M83.5,75.9c-0.7-0.4-1.2-0.7-1.6-1.1c-2-2-3.9-3.9-5.9-5.9c-0.9-0.9-1.3-1.8-0.3-2.8c0.9-0.9,1.9-0.6,2.7,0.2 c2,2,4.1,4,6.1,6.1c0.4,0.5,0.6,1.5,0.5,2.2C84.9,75.2,84.1,75.5,83.5,75.9z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M27.2,71.6c0.4-0.7,0.6-1.1,0.9-1.6c1.6-1.7,3.3-3.4,4.9-5c0.8-0.8,1.8-1.1,2.7-0.2c0.8,0.9,0.6,1.8-0.2,2.5 c-1.7,1.7-3.4,3.4-5.1,5c-0.5,0.4-1.4,0.6-2,0.4C28,72.9,27.7,72.1,27.2,71.6z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M23.2,46.8c-1.1,0-2.3,0-3.4,0c-1.1,0-1.7-0.6-1.8-1.7c0-1.1,0.7-1.7,1.7-1.8c2.4-0.1,4.7-0.1,7.1,0 c1.1,0,1.9,0.8,1.6,1.8c-0.2,0.7-1,1.4-1.7,1.6C25.6,47,24.3,46.8,23.2,46.8z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M89.5,46.8c-1.1,0-2.3,0-3.4,0c-1.1,0-1.9-0.7-1.7-1.7c0.1-0.7,1-1.6,1.6-1.6c2.4-0.2,4.8-0.2,7.2,0 c0.6,0.1,1.4,1.1,1.6,1.7c0.2,1.1-0.7,1.6-1.7,1.7C91.8,46.8,90.7,46.8,89.5,46.8z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M35.8,24.7c-0.2,0.3-0.5,1.1-0.9,1.2c-0.6,0.2-1.6,0.2-2-0.1c-1.8-1.6-3.5-3.4-5.2-5.2c-0.3-0.4-0.3-1.6,0.1-2 c0.3-0.4,1.6-0.7,2-0.5c2,1.8,3.9,3.8,5.8,5.7C35.7,23.9,35.7,24.3,35.8,24.7z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M54.7,11.8c0-1.1,0-2.3,0-3.4s0.7-1.8,1.7-1.8c1.1,0,1.7,0.7,1.7,1.8c0,2.3,0,4.6,0,6.9c0,1.1-0.6,1.7-1.7,1.7 s-1.6-0.7-1.7-1.8C54.7,14.1,54.7,12.9,54.7,11.8z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M82.8,19.3c0,1.4-4.3,5.8-5.5,5.7c-0.5-0.1-1.2-0.5-1.4-0.9c-0.2-0.5-0.2-1.4,0.2-1.8c1.2-1.4,2.6-2.8,4-4 c0.4-0.3,1.2-0.3,1.8-0.1C82.4,18.3,82.6,19,82.8,19.3z"
});

var SvgDaylightIcon = function SvgDaylightIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 462.8 93",
    style: {
      enableBackground: "new 0 0 462.8 93"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDaylightIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/daylight-icon.09e599e1.svg";
export { ForwardRef as ReactComponent };